var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta-blocking-modal-backdrop"},[_c('div',{staticClass:"hl-cta",class:this.bgColor,style:(_vm.customStyles)},[_c('close-x',{attrs:{"close":_vm.close}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }